import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export function createWebPersister() {
  return createSyncStoragePersister({
    storage: localStorage,
  });
}
